import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles';
import moment from 'moment-timezone';
import momentDurationFormatSetup from 'moment-duration-format';
// uncomment the wdyr import to enable why-did-you-render
// import './wdyr'; // Note this must be the first import for it to work
import { Application } from '@/main/Application.page';
import { isSystemTest } from '@/core/utilities';
import { headlessRenderMode } from '@/services/headlessCapture.utilities';

if (!Array.prototype.uniqBy) {
  Array.prototype.uniqBy = function <T>(this: Array<T>, callback: (item: T) => any): Array<T> {
    const seenValues = new Set<any>();

    return this.filter((item) => {
      const callbackValue = callback(item);
      if (seenValues.has(callbackValue)) {
        return false;
      }

      seenValues.add(callbackValue);

      return true;
    });
  };
}

// https://github.com/seeq12/crab/pull/5962/files#r1446538620
momentDurationFormatSetup(moment as any);

const rootEl = document.getElementById('sqApp') || document.createElement('div');
if (isSystemTest() || headlessRenderMode()) {
  rootEl.classList.add('isHeadlessMode');
}
const root = createRoot(rootEl);
root.render(<Application />);
